import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20anime%20illustration%20with%20warm%20sunset%20gradient%20and%20silhouette%20of%20reading%20person%2C%20cozy%20atmospheric%20scene%20with%20floating%20manga%20pages%2C%20dreamy%20golden%20hour%20lighting%2C%20soft%20and%20inspirational%20mood%2C%20clean%20composition%20with%20cinematic%20feel&width=1800&height=700&seq=cta-bg-main&orientation=landscape"
        alt="加入漫蛙"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/30"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div>
            <h2 className="text-white font-heading text-3xl md:text-5xl font-bold leading-tight mb-4">
              准备好开启
              <br />
              你的漫画之旅了吗？
            </h2>
            <p className="text-white/70 text-sm md:text-base max-w-md">
              加入5000万蛙友的行列，海量漫画免费看，每日更新不停歇。下载漫蛙App，随时随地畅享二次元世界。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/rexue"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-foreground-950 rounded-full text-sm font-medium hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-download-line"></i>
              下载App
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}